module.exports = __webpack_public_path__ + "img/3.94a87602.png";